document.addEventListener('DOMContentLoaded', () => {
  // nav parent dom element
  const $navParent = document.querySelector('.x-header');
  // nav dom element
  const $nav = document.querySelector('.x-header__nav');
  const headerActiveClass = 'x-header--active';
  function toggleMobileMenu() {
    $nav.classList.toggle('x-header__nav--active');
    $navParent.classList.toggle(headerActiveClass);
    if ($nav.classList.contains('x-header__nav--active')) {
      xUtils.showMask();
    } else {
      xUtils.hideMask();
    }
  }
  function initMenuEvents() {
    // mobile menu trigger button
    const $moboleNavBtn = document.querySelector('.x-header-menu__button--mobile');
    // mobile menu event handler
    $moboleNavBtn.addEventListener('click', () => {
      toggleMobileMenu();
    });
    // desktop menu display animation timeout
    let desktopMenuDisplayTimeout = null;
    // current active mobile menu item
    let $currentItem = null;
    // mobile menu item event handler
    const $navItemList = document.querySelectorAll('.x-header-nav__li');
    $navItemList.forEach(($item, index) => {
      // menu hover trigger event
      $item.addEventListener('mouseenter', () => {
        if (xUtils.isMobile()) return;
        clearTimeout(desktopMenuDisplayTimeout);
        // close other menu
        $navItemList.forEach(($otherItem) =>
          $otherItem.classList.remove('x-header-nav__li--active')
        );
        // activate menu
        $item.classList.add('x-header-nav__li--active');
        $item.parentNode.classList.add('x-header-nav--active');
        $navParent.classList.add(headerActiveClass);
      });
      // menu leave trigger event
      $item.addEventListener('mouseleave', () => {
        if (xUtils.isMobile()) return;
        desktopMenuDisplayTimeout = setTimeout(() => {
          $item.classList.remove('x-header-nav__li--active');
          $item.parentNode.classList.remove('x-header-nav--active');
          $navParent.classList.remove(headerActiveClass);
        }, 300);
      });
      // menu click trigger event
      $item.addEventListener('click', (e) => {
        if (!xUtils.isMobile()) {
          const link = $item.dataset && $item.dataset.link;
          if (link) {
            window.location.href = link;
          }
          return;
        }
        const $subMenu = $item.querySelector('.x-header-dropdown__mobile');
        if (!$subMenu) {
          toggleMobileMenu();
          return;
        }
        if ($currentItem && $currentItem !== $item) {
          $currentItem
            .querySelector('.x-header-dropdown__mobile')
            .classList.remove('x-header-dropdown__mobile--shown');
          $currentItem
            .querySelector('.x-header-list__text')
            ?.classList.remove('x-header-list__text--active');
        }
        $item
          .querySelector('.x-header-dropdown__mobile')
          .classList.add('x-header-dropdown__mobile--shown');
        $item.querySelector('.x-header-list__text').classList?.add('x-header-list__text--active');
        $currentItem = $item;
      });

      // init open first menu
      if (index === 0) {
        $item
          .querySelector('.x-header-dropdown__mobile')
          ?.classList.add('x-header-dropdown__mobile--shown');
        $item.querySelector('.x-header-list__text')?.classList.add('x-header-list__text--active');
        $currentItem = $item;
      }
    });
    // click outside event
    document.addEventListener('click', (event) => {
      // only handle close event
      if (!$nav.classList.contains('x-header__nav--active')) return;

      if (!$nav.contains(event.target)) {
        toggleMobileMenu();
      }
    });
  }
  function initSwiperMenu() {
    // init dropdown's trigger
    document.querySelectorAll('.x-header-list__text').forEach(($item) => {
      const $swiperMenu = document.querySelector(`#${$item.dataset.menu}`);
      const menuType = $item.dataset.menuType;

      if (menuType !== 'product_list') return;

      // init swiper
      const swiper = new Swiper($swiperMenu, {
        direction: 'horizontal',
        slidesPerView: 'auto',
        // freeMode: true, // 惯性滚动
        spaceBetween: 60,
        mousewheel: {
          enabled: true,
          sensitivity: 1, // 鼠标滚轮灵敏度
          releaseOnEdges: false, // 防止边界滚动释放到浏览器
          forceToAxis: true,
        },
        navigation: {
          nextEl: '.x-header-dropdown__button-next',
          prevEl: '.x-header-dropdown__button-prev',
        },
        scrollbar: {
          el: null,
        },
      });
      // prevent historical scroll
      $swiperMenu.addEventListener(
        'wheel',
        (e) => {
          if (Math.abs(e.deltaX) > Math.abs(e.deltaY) || Math.abs(e.deltaY) < 10) {
            e.preventDefault();
          }
        },
        { passive: false }
      );
      // prevent location back/forward
      $swiperMenu.addEventListener(
        'touchmove',
        (e) => {
          e.preventDefault();
        },
        { passive: false }
      );
    });
  }
  initMenuEvents();
  initSwiperMenu();
  // location modal event handler
  const $locationBtn = document.querySelectorAll('.x-header-operation__location');
  const $localizationContainer = document.querySelector('.x-header-location__container');
  const MODAL_NAME = 'location-modal';
  const selectedClass = 'x-header-location__list-item--selected';
  const toggleItemActive = () => {
    const $locationList = document.querySelector('.x-header-location__list');
    const $locationListItems = $locationList.querySelectorAll('li');
    const currentPath = window.location.pathname;
    $locationListItems.forEach(($item) => {
      const market = $item.dataset.market;

      if (market === 'us') {
        // us is main market, so we need to check if the current path is not in any other market
        // if it is, we need to remove the active class from the us item
        if (!currentPath.match(/^\/(en-ca|en-eu|en-int|en-intl)/)) {
          $item.classList.add(selectedClass);
        } else {
          $item.classList.remove(selectedClass);
        }
      } else {
        const marketUrl = `en-${market}`;
        if (currentPath.includes(marketUrl)) {
          $item.classList.add(selectedClass);
        } else {
          $item.classList.remove(selectedClass);
        }
      }
    });
  };
  $locationBtn.forEach(($btn) => {
    $btn.addEventListener('click', () => {
      publish(PUB_SUB_EVENTS.xModalOpen, {
        modalName: MODAL_NAME,
      });
      $localizationContainer.style.display = 'block';
      toggleItemActive();
    });
  });
  subscribe(PUB_SUB_EVENTS.xModalConfirm, (data) => {
    if (data.modalName !== MODAL_NAME) return;
    const $target = data.targetNode;
    const marketName = $target.dataset.market;
    const currentPath = window.location.pathname;
    let targetMarket;

    switch (marketName) {
      case 'intl':
        targetMarket = 'en-intl';
        break;
      case 'ca':
        targetMarket = 'en-ca';
        break;
      case 'eu':
        targetMarket = 'en-eu';
        break;
      case 'cn':
        window.location.replace('https://www.xidesheng.com/');
        return;
      default:
        targetMarket = '';
    }

    const cleanPath = currentPath.replace(/^\/(en-us|en-ca|en-eu|en-intl)/, '');
    // switch market
    let newPath = '';
    if (targetMarket === '') {
      newPath = cleanPath || '/';
    } else {
      newPath = '/' + targetMarket + cleanPath;
    }

    if (currentPath !== newPath && currentPath !== newPath + '/') {
      window.location.replace(newPath);
    }
  });
  // header scroll event handler
  let lastScrollY = window.scrollY;
  const headerHideClass = 'x-header--hide';
  const threshold = 10;
  window.addEventListener(
    'scroll',
    () => {
      if (window.IS_DEALER_MODE) return;
      const currentScrollY = window.scrollY;

      // prevent scroll when menu is active
      if ($navParent.classList.contains(headerActiveClass)) {
        $navParent.classList.remove(headerHideClass);
        publish(PUB_SUB_EVENTS.xHeaderShow);
        lastScrollY = currentScrollY;
        return;
      }

      // to prevent boundry scroll
      if (currentScrollY <= 0) {
        $navParent.classList.remove(headerHideClass);
        publish(PUB_SUB_EVENTS.xHeaderShow);
        return;
      }
      if (Math.abs(currentScrollY - lastScrollY) > threshold) {
        if (currentScrollY > lastScrollY && currentScrollY > 100) {
          // scroll down -> hide
          $navParent.classList.add(headerHideClass);
          publish(PUB_SUB_EVENTS.xHeaderHide);
        } else {
          // scroll up -> show
          $navParent.classList.remove(headerHideClass);
          publish(PUB_SUB_EVENTS.xHeaderShow);
        }
        lastScrollY = currentScrollY;
      }
    },
    { passive: true }
  );
  document.querySelectorAll('.x-header-dropdown').forEach(($dropdown) => {
    $dropdown.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });
  // avatar
  // const avatarColors = [
  //   '#18181B', // Carbon Black (纯粹的碳纤维黑)
  //   '#0F172A', // Midnight Navy (极深的午夜蓝)
  //   '#11323B', // Deep Teal (提取自你们 Astana 涂装的深青色)
  //   '#27272A', // Slate Gray (偏冷的深石板灰)
  //   '#292524', // Espresso (带有极弱暖色调的深咖黑)
  //   '#1F2937', // Gunmetal (深枪灰)
  // ];

  // const avatars = document.querySelectorAll('.x-header-account__avatar');

  // avatars.forEach((avatar) => {
  //   const name = avatar.getAttribute('data-name');
  //   if (!name) return;

  //   const charCode = name.charCodeAt(0);
  //   const colorIndex = charCode % avatarColors.length;

  //   avatar.style.backgroundColor = avatarColors[colorIndex];
  // });
});
